import emiConfig from "./configs/emiConfig";
import loanEligibilityCheckerConfig from "./configs/loanEligibilityCheckerConfig";
import prepaymentCalculatorConfig from "./configs/prepaymentCalculatorConfig";
import ltvStampDutyCalculatorConfig from "./configs/ltvStampDutyCalculatorConfig";
import balanceTransferCalculatorConfig from "./configs/balanceTransferCalculatorConfig";
import taxBenefitCalculatorConfig from "./configs/taxBenefitCalculatorConfig";
import detailedFoirCalculatorConfig from "./configs/detailedFoirCalculatorConfig";
import lenderComparisonCalculatorConfig from "./configs/lenderComparisonCalculatorConfig";

export default [
  emiConfig,
  // loanEligibilityCheckerConfig,
  prepaymentCalculatorConfig,
  // ltvStampDutyCalculatorConfig,
  balanceTransferCalculatorConfig,
  taxBenefitCalculatorConfig,
  // detailedFoirCalculatorConfig,
  lenderComparisonCalculatorConfig
];
